/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamGradeCriteriaQueryResponse,
  GetApiV1ExamGradeCriteria401,
  GetApiV1ExamGradeCriteria500,
} from "../../types/examEvaluationController/GetApiV1ExamExamGradeCriteria.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamExamGradeCriteria } from "../../clients/examEvaluationController/getApiV1ExamExamGradeCriteria.ts";

export const getApiV1ExamExamGradeCriteriaQueryKey = () =>
  [{ url: "/api/v1/exam/exam-grade-criteria" }] as const;

export type GetApiV1ExamExamGradeCriteriaQueryKey = ReturnType<
  typeof getApiV1ExamExamGradeCriteriaQueryKey
>;

export function getApiV1ExamExamGradeCriteriaQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamExamGradeCriteriaQueryKey();
  return queryOptions<
    GetApiV1ExamGradeCriteriaQueryResponse,
    ResponseErrorConfig<
      GetApiV1ExamGradeCriteria401 | GetApiV1ExamGradeCriteria500
    >,
    GetApiV1ExamGradeCriteriaQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamExamGradeCriteria({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todos os critérios de nota disponíveis para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Listar critérios de nota para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/exam-grade-criteria}
 */
export function useGetApiV1ExamExamGradeCriteria<
  TData = GetApiV1ExamGradeCriteriaQueryResponse,
  TQueryData = GetApiV1ExamGradeCriteriaQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamExamGradeCriteriaQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamGradeCriteriaQueryResponse,
        ResponseErrorConfig<
          GetApiV1ExamGradeCriteria401 | GetApiV1ExamGradeCriteria500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1ExamExamGradeCriteriaQueryKey();

  const query = useQuery(
    {
      ...getApiV1ExamExamGradeCriteriaQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetApiV1ExamGradeCriteria401 | GetApiV1ExamGradeCriteria500
    >
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
